<template>
  <div class="barkhausen-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>非连续磁化 | 磁畴壁钉扎$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- B-H Curve (Dashed base) -->
          <path d="M 50 200 Q 200 200 350 40" fill="none" stroke="#333" stroke-dasharray="2" />
          
          <!-- Jagged Barkhausen Curve -->
          <path :d="barkPath" fill="none" stroke="#00d2ff" stroke-width="2" />

          <!-- Magnetic Domain View -->
          <g transform="translate(250, 150)">
             <rect width="100" height="60" fill="rgba(255,255,255,0.05)" stroke="#555" />
             <g v-for="d in domains" :key="d.id" :transform="`translate(${d.x}, ${d.y})`">
                <line x1="0" y1="0" :x2="8*Math.cos(d.angle)" :y2="8*Math.sin(d.angle)" stroke="#ffd700" stroke-width="1.5" />
             </g>
             <text x="0" y="75" fill="#888" font-size="8">微观磁畴颗粒噪声</text>
          </g>

          <!-- Current point -->
          <circle :cx="50 + h*3" :cy="yPos" r="4" fill="#ff4757" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>检测到磁噪声: {{ jumpCount }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>缓慢增加外磁场 H</label>
             <el-slider v-model="h" :min="0" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>当外磁场平滑改变时，铁磁材料的磁化强度并不是连续变化的，而是由无数个微小的**阶跳**组成。这是因为内部磁畴在转动时会被杂质或缺陷“钉扎”，必须积累足够的能量才能瞬间跨过障碍。这种跳跃产生的感应电流在放大器中听起来像**爆裂声**（Barkhausen噪声），它是磁畴存在的直接证据。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BarkhausenEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      h: 0,
      steps: [],
      domains: Array.from({length: 20}, (_, i) => ({
         id: i,
         x: (i%5) * 20 + 5,
         y: Math.floor(i/5) * 15 + 5,
         angle: Math.random() * Math.PI * 2
      }))
    }
  },
  computed: {
    yPos() {
       let base = 200 - (this.h * 1.6);
       // Add jumpy noise
       let noise = 0;
       this.steps.forEach(s => {
          if (this.h > s.h) noise += s.val;
       });
       return base - noise;
    },
    barkPath() {
       let d = "M 50 200 ";
       let currentY = 200; // eslint-disable-line no-unused-vars
       for (let i = 0; i < this.h; i++) {
          let x = 50 + i * 3;
          let y = 200 - (i * 1.6);
          let jump = 0;
          this.steps.forEach(s => { if (i > s.h) jump += s.val; });
          d += `L ${x} ${y - jump} `;
       }
       return d;
    },
    jumpCount() {
       return this.steps.filter(s => this.h > s.h).length;
    }
  },
  watch: {
    h(val) {
       // Update domain angles jumpily
       this.domains.forEach(d => {
          if (Math.random() > 0.95) {
             d.angle = (val / 100) * Math.PI;
          }
       });
    }
  },
  created() {
     // Pre-generate jumps
     for (let i = 0; i < 20; i++) {
        this.steps.push({ h: Math.random() * 100, val: Math.random() * 5 });
     }
  }
}
</script>

<style scoped lang="scss">
.barkhausen-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
